import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { SiGoogleadsense, SiExercism } from 'react-icons/si';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Close from '@material-ui/icons/Close';
import ListSubheader from '@material-ui/core/ListSubheader';
import Edit from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import Card from 'src/components/sharedComponents/Card/Card';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import { permitsList, minPermisos } from 'src/constants/permits';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import Search from 'src/components/sharedComponents/SearchInput';
import { MenuItem } from '@material-ui/core';
import styles, { SelectInput } from '../styles';

const useStyles = makeStyles(styles);

const ReportsControlPage = ({
  reports,
  openForm,
  onDelete,
  permisos,
  setIdReport,
  handleUpdate,
  handleSubmit,
  onChangeInput,
  onCreateReport,
  onSearchReports,
  handleCreateReport,
  handleSearchReport,
}) => {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  const listRef = useRef(null);
  const classes = useStyles();
  const history = useHistory();
  const minValue = permisos[permitsList.REPORTE_DATASTUDIO];

  const handleClickList = (value) => {
    setOpen({ [value]: !open[value] ? !open[value] : !open[value] });
    setEdit({ [value]: !edit[value] ? edit[value] : !edit[value] });
  };

  const handleClickEdit = (value) => {
    setEdit({ [value]: !edit[value] ? !edit[value] : !edit[value] });
  };

  const handleClickClose = (value) => {
    setOpen({ [value]: !open[value] ? !open[value] : !open[value] });
    setEdit({ [value]: !edit[value] ? !edit[value] : !edit[value] });
  };

  const handlePermits = (value) => {
    setIdReport(value);
    history.push('/admin/reports/permission');
  };

  return (
    <main style={{ margin: '10px' }}>
      <CardTitle
        title="Administración de reportes"
        subTitle=" Permisos visualización y administración de reportes"
      />
      {minValue >= minPermisos.CREAR ? (
        <Card plain>
          <Button type="onSubmit" onClick={onCreateReport} color="warning">
            Crear Reporte
          </Button>
        </Card>
      ) : null}

      {/* Formulario de creación */}
      {openForm && (
        <Card>
          <form onSubmit={handleSubmit}>
            <CardBody>
              <CustomInput
                labelText="Nombre"
                id="Nombre"
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}
                inputProps={{
                  onChange: (event) => handleCreateReport('nombre', event.target.value),
                  type: 'text',
                  autoComplete: 'off',
                }}
              />
              <CustomInput
                labelText="Url"
                id="Url"
                formControlProps={{
                  required: true,
                  fullWidth: true,
                }}
                inputProps={{
                  onChange: (event) => handleCreateReport('url', event.target.value),
                  type: 'url',
                  autoComplete: 'off',
                }}
              />
              <CustomInput
                labelText="Descripción"
                id="Descripción"
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}
                inputProps={{
                  onChange: (event) => handleCreateReport('descripcion', event.target.value),

                  type: 'text',
                  autoComplete: 'off',
                }}
              />
              <SelectInput
                className={classes.selectInput}
                fullWidth
                required
                label="Tipo"
                variant="standard"
                select
                onChange={(event) => handleCreateReport('tipo', event.target.value)}
              >
                <MenuItem value="MOTOS A COMBUSTION">
                  MOTOS A COMBUSTION
                </MenuItem>
                <MenuItem value="PRESIDENCIA">PRESIDENCIA</MenuItem>
                <MenuItem value="MICE">MICE</MenuItem>
                <MenuItem value="REPUESTOS">REPUESTOS</MenuItem>
                <MenuItem value="CARPA">CARPA</MenuItem>
              </SelectInput>
            </CardBody>
            <CardFooter>
              <Button type="onSubmit" color="warning">
                Crear
              </Button>
            </CardFooter>
          </form>
        </Card>
      )}
      {/* Lista de update / delete */}
      <Card>
        <CardBody>
          <Search
            type="email"
            handleSearch={onSearchReports}
            text="Buscar reportes asignados por correo"
          />
          <Button color="warning" onClick={handleSearchReport}>
            Buscar
          </Button>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <List
            subheader={<ListSubheader>Lista de reportes</ListSubheader>}
            className={classes.root}
            component="div"
            ref={listRef}
            key="Lista_Principal"
          >
            <div key="list_pkey">
              <Search
                handleSearch={onChangeInput}
                text="Busqueda de reportes"
              />
              <form onSubmit={handleUpdate}>
                {Array.isArray(reports)
                  && reports.map((value, index) => (
                    <div key={`key11${value.id}`}>
                      <ListItem
                        id={value.id}
                        key={`key${value.id}`}
                        aria-expanded={open}
                        button
                        style={{
                          backgroundColor: value?.nothere ? null : '#FFFDDC',
                        }}
                        onClick={() => handleClickList(value.id)}
                      >
                        <ListItemIcon>
                          {!value?.isUser ? (
                            <>
                              <SiGoogleadsense color="blue" />
                            </>
                          ) : (
                            <>
                              <SiExercism color="green" />
                            </>
                          )}
                        </ListItemIcon>
                        <ListItemText
                          primary={value.nombre || value.title}
                          secondary={value.descripcion}
                        />
                        <Grid item>
                          {open[value?.id] ? <ExpandLess /> : <ExpandMore />}
                        </Grid>
                      </ListItem>
                      <div key={`key2${value?.id}`}>
                        <Collapse
                          in={open[value?.id]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List key="nav2" component="div" disablePadding>
                            <ListItem className={classes.nested}>
                              <ListItemIcon>
                                <ArrowForwardIosIcon />
                              </ListItemIcon>
                              {!edit[value?.id] && (
                                <ListItemText primary={value?.url} />
                              )}
                              {edit[value?.id] && (
                                <>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Nombre"
                                        id={value?.id}
                                        value={value?.nombre}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => handleCreateReport(
                                            'nombre',
                                            event.target.value,
                                            value.idIndex,
                                          ),
                                          type: 'text',
                                          autoComplete: 'off',
                                          defaultValue: value?.nombre,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Url"
                                        id="name"
                                        value={value.url}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => handleCreateReport(
                                            'url',
                                            event.target.value,
                                            value.idIndex,
                                          ),
                                          type: 'url',
                                          autoComplete: 'off',
                                          defaultValue: value?.url,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <CustomInput
                                        labelText="Descripción"
                                        id="name"
                                        value={
                                          value?.descripcion || value.title
                                        }
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) => handleCreateReport(
                                            'descripcion',
                                            event.target.value,
                                            value.idIndex,
                                          ),
                                          type: 'text',
                                          autoComplete: 'off',
                                          defaultValue: value.descripcion,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <SelectInput
                                        className={classes.selectInput}
                                        fullWidth
                                        required
                                        label="Tipo"
                                        variant="standard"
                                        value={value?.tipo || ''}
                                        select
                                        onChange={(event) => handleCreateReport(
                                          'tipo',
                                          event.target.value,
                                          value.idIndex,
                                        )}
                                      >
                                        <MenuItem value="MOTOS A COMBUSTION">
                                          MOTOS A COMBUSTION
                                        </MenuItem>
                                        <MenuItem value="PRESIDENCIA">
                                          PRESIDENCIA
                                        </MenuItem>
                                        <MenuItem value="MICE">MICE</MenuItem>
                                        <MenuItem value="REPUESTOS">
                                          REPUESTOS
                                        </MenuItem>
                                        <MenuItem value="CARPA">
                                          CARPA
                                        </MenuItem>
                                      </SelectInput>
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                              <ListItemSecondaryAction
                                className={
                                  Object.values(edit).pop()
                                    ? classes.iconsEdit
                                    : null
                                }
                              >
                                {edit[value.id] !== true ? (
                                  <>
                                    {minValue >= minPermisos.ACTUALIZAR && (
                                      <>
                                        <IconButton
                                          color="primary"
                                          aria-label="editButton"
                                          component="span"
                                          onClick={() => handleClickEdit(value.id)}
                                        >
                                          <Edit
                                            className={
                                              classes.tableActionButtonIcon
                                            }
                                            style={{ color: 'blue' }}
                                          />
                                        </IconButton>
                                      </>
                                    )}
                                    {minValue >= minPermisos.ELIMINAR && (
                                      <IconButton
                                        color="primary"
                                        aria-label="editButton"
                                        component="span"
                                        onClick={() => onDelete(value.id)}
                                      >
                                        <DeleteIcon
                                          className={
                                            classes.tableActionButtonIcon
                                          }
                                          style={{ color: 'rgb(244, 67, 54)' }}
                                        />
                                      </IconButton>
                                    )}
                                    <IconButton
                                      color="primary"
                                      aria-label="editButton"
                                      component="span"
                                      onClick={() => handlePermits(value.id)}
                                    >
                                      <AccountCircleIcon
                                        className={
                                          classes.tableActionButtonIcon
                                        }
                                      />
                                    </IconButton>
                                  </>
                                ) : null}
                                {edit[value.id] === true ? (
                                  <>
                                    <IconButton
                                      color="primary"
                                      aria-label="saveButton"
                                      component="span"
                                      onClick={() => handleUpdate(value.idIndex)}
                                    >
                                      <SaveIcon
                                        className={
                                          classes.tableActionButtonIcon
                                        }
                                        style={{ color: ' #43a047' }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      color="primary"
                                      aria-label="closeButto"
                                      component="span"
                                      onClick={() => handleClickClose(value.id)}
                                    >
                                      <Close
                                        className={
                                          classes.tableActionButtonIcon
                                        }
                                        style={{ color: 'rgb(244, 67, 54)' }}
                                      />
                                    </IconButton>
                                  </>
                                ) : null}
                              </ListItemSecondaryAction>
                            </ListItem>
                          </List>
                        </Collapse>
                      </div>
                    </div>
                  ))}
              </form>
            </div>
          </List>
        </CardBody>
      </Card>
    </main>
  );
};

export default ReportsControlPage;
